export enum IntendedTitlesTypes {
    SET = 'SET_INTENDED_TITLES',
    UPDATE = 'UPDATE_INTENDED_TITLES',
    RESET = 'RESET_INTENDED_TITLES'
}

export enum DocsAvailabilityDetailsType {
    REQUEST = 'FETCH_PURCHASE_DEED_DETAILS_REQUEST',
    SUCCESS = 'FETCH_PURCHASE_DEED_DETAILS_SUCCESS',
    NEXT = 'FETCH_PURCHASE_DEED_DETAILS_NEXT',
    FAILURE = 'FETCH_PURCHASE_DEED_DETAILS_FAILURE',
    RESET = 'FETCH_PURCHASE_DEED_DETAILS_RESET'
}

export enum SelectedCopiesType {
    ADD = 'ADD_COPIES',
    REMOVE = 'REMOVE_COPIES',
    RESET = 'RESET_SELECTED_COPIES'
}

export const SET_DEED_MAP_DETAILS = 'SET_DEED_MAP_DETAILS';

export enum CreateTitleDeedOrder {
    REQUEST = 'CREATE_TITLE_DEED_ORDER_REQUEST',
    SUCCESS = 'CREATE_TITLE_DEED_ORDER_SUCCESS',
    FAILURE = 'CREATE_TITLE_DEED_ORDER_FAILURE',
    WARNING = 'CREATE_TITLE_DEED_ORDER_WARNING'
}

export enum UpdateTitleDeedOrder {
    REQUEST = 'UPDATE_TITLE_DEED_ORDER_REQUEST',
    SUCCESS = 'UPDATE_TITLE_DEED_ORDER_SUCCESS',
    FAILURE = 'UPDATE_TITLE_DEED_ORDER_FAILURE'
}

export enum UnavailableDocsType {
    SET_UNAVAILABLE_DOCS = 'SET_UNAVAILABLE_DOCS',
    RESET_UNAVAILABLE_DOCS = 'RESET_UNAVAILABLE_DOCS'
}

// export const SET_PURCHASE_DEED_PAYMENT_METHOD = 'SET_PURCHASE_DEED_PAYMENT_METHOD';

// export const CREATE_TITLE_DEED_ORDER_REQUEST = 'CREATE_TITLE_DEED_ORDER_REQUEST';
// export const CREATE_TITLE_DEED_ORDER_SUCCESS = 'CREATE_TITLE_DEED_ORDER_SUCCESS';
// export const CREATE_TITLE_DEED_ORDER_FAILURE = 'CREATE_TITLE_DEED_ORDER_FAILURE';
// export const CREATE_TITLE_DEED_ORDER_WARNING = 'CREATE_TITLE_DEED_ORDER_WARNING';

// export const UPDATE_TITLE_DEED_ORDER_REQUEST = 'UPDATE_TITLE_DEED_ORDER_REQUEST';
// export const UPDATE_TITLE_DEED_ORDER_SUCCESS = 'UPDATE_TITLE_DEED_ORDER_SUCCESS';
// export const UPDATE_TITLE_DEED_ORDER_FAILURE = 'UPDATE_TITLE_DEED_ORDER_FAILURE';
